import { Button } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

import styles from './YearSelector.module.scss';
import { Props } from './YearSelector.types';

const YearSelector = ({ year, availableYears, onChange }: Props) => {
  const sortedYears = [...availableYears].sort((a, b) => a - b);
  const currentIndex = sortedYears.indexOf(year);
  const canGoPrev = currentIndex > 0;
  const canGoNext = currentIndex < sortedYears.length - 1;

  return (
    <div className={styles.group}>
      <Button.Group>
        <Button
          variant="default"
          px="xs"
          disabled={!canGoPrev}
          onClick={() => canGoPrev && onChange(sortedYears[currentIndex - 1])}
        >
          <IconChevronLeft size={14} />
        </Button>
        <Button.GroupSection
          variant="default"
          bg="var(--mantine-color-body)"
          miw={52}
          ta="center"
          fw={600}
        >
          {year}
        </Button.GroupSection>
        <Button
          variant="default"
          px="xs"
          disabled={!canGoNext}
          onClick={() => canGoNext && onChange(sortedYears[currentIndex + 1])}
        >
          <IconChevronRight size={14} />
        </Button>
      </Button.Group>
    </div>
  );
};

export default YearSelector;
